import {
    INITIALIZE,
    INITIALIZE_FAILURE,
    INITIALIZE_SUCCESS,
} from '../actionTypes';
import { createProposalModalActions } from '../reducer';

import fetchPanelBrands from './fetchPanelBrands';
import fetchRoofTypes from './fetchRoofTypes';

export default () => (dispatch) => {
    dispatch(createProposalModalActions[INITIALIZE]());
    Promise.all([dispatch(fetchPanelBrands()), dispatch(fetchRoofTypes())])
        .then(() => dispatch(createProposalModalActions[INITIALIZE_SUCCESS]()))
        .catch(() =>
            dispatch(createProposalModalActions[INITIALIZE_FAILURE]()),
        );
};
